import { RouteConfig } from 'vue-router'
import authorRoute from './author'
import bookRoute from './book'
import collectionRoute from './collection'
import configurationRoute from '@/router/routes/configuration'
import lazyImporter from '@/utils/lazyImporter'
import menuRoute from '@/router/routes/menu'
import pageRoute from './page'
import postRoute from './post'
import profileRoute from './profile'
import userRoute from './user'

const routes: RouteConfig[] = [
  {
    component: lazyImporter('Dashboard'),
    meta: { title: 'dashboard', icon: 'dashboard', exact: true },
    name: 'dashboard',
    path: '/'
  },
  {
    component: lazyImporter('Login'),
    meta: { title: 'login', hidden: true },
    name: 'login',
    path: '/login',
    redirect: { name: 'login_form' },
    children: [
      {
        component: lazyImporter('login/LoginForm'),
        meta: { title: 'loginForm', hidden: true },
        name: 'login_form',
        path: ''
      },
      {
        component: lazyImporter('login/ForgottenPassword'),
        meta: { title: 'forgottenPassword', hidden: true },
        name: 'forgotten_password',
        path: 'forgotten-password'
      },
      {
        component: lazyImporter('login/ResetPassword'),
        meta: { title: 'resetPassword', hidden: true },
        name: 'reset_password',
        path: 'reset-password/:token',
        props: true
      }
    ]
  },
  {
    component: lazyImporter('Error401'),
    meta: { title: 'forbidden', hidden: true },
    name: 'error401',
    path: '/forbidden'
  },
  {
    component: lazyImporter('Error404'),
    meta: { title: 'error404', hidden: true },
    name: 'error404',
    path: '*'
  },
  bookRoute,
  authorRoute,
  collectionRoute,
  postRoute,
  pageRoute,
  profileRoute,
  menuRoute,
  userRoute,
  configurationRoute
]

export default routes
